import axiosInstance from 'api/axiosInstance';

export const deleteBucketFile = async (id: string): Promise<void> => {
	await axiosInstance.delete(`/api3.2/bucket/${id}`);
};
